export const updateDocumentAdminService = (fetch) => async ({ document, file }) => {
  try {
    const response = await fetch({ url: `/api/v1/documentos-admin/${document}`, method: 'post', body: file })
    return response
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message)
  }
}
